/**
 * GAS WARS wordmark and mark. UI_UX section 2.
 *
 * The mark is a hexagon outline with a lightning bolt cut through it: gas plus
 * block. The lockup sets the name in Space Grotesk with +8% tracking and
 * swaps the two "A" glyphs for a hollow triangle, drawn as inline SVG so the
 * substitution is presentational and the accessible name stays "GAS WARS".
 */

import styles from './Logo.module.css';

export interface LogoProps {
  /** Mark only, or the full lockup. */
  variant?: 'mark' | 'lockup';
  size?: number;
  className?: string;
}

export function Logo({ variant = 'lockup', size = 26, className }: LogoProps) {
  if (variant === 'mark') return <Mark size={size} className={className} />;
  return (
    <span className={[styles.lockup, className].filter(Boolean).join(' ')} role="img" aria-label="GAS WARS">
      <Mark size={size} />
      <span className={styles.word} style={{ fontSize: Math.round(size * 0.72) }} aria-hidden="true">
        G<TriangleA />S<span className={styles.gap} />W<TriangleA />RS
      </span>
    </span>
  );
}

function Mark({ size, className }: { size: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      className={className}
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M16 2.6 27.6 9.3v13.4L16 29.4 4.4 22.7V9.3z"
        stroke="var(--accent)"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M18.4 7.6 11.2 17.2h4.5L13.6 24.4 21 14.4h-4.8z" fill="var(--accent)" />
    </svg>
  );
}

/** A hollow triangle standing in for the letter A. */
function TriangleA() {
  return (
    <svg className={styles.triangle} viewBox="0 0 20 24" fill="none" aria-hidden="true" focusable="false">
      <path d="M10 3.2 18.4 21H1.6z" stroke="var(--accent)" strokeWidth="2.6" strokeLinejoin="round" />
    </svg>
  );
}
